import React from "react";
import { getUscCarFilterUrlForDealer } from "../../../../../shared-logic/utils/uscUtils";
import DealerContactInfo from "../../common/DealerContactInfo";
import { useUscSelector } from "../../../../redux/store";
import { UscLabel, useUscLabel, useUscOptionalLabel } from "../../../../utils/labels";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import Button from "../../../../../shared-components/toyota/styles/atoms/Button";
import * as Styles from "./PdpDealer.styles";
import { trackAemContactDealerCtas, trackAemDealerSeeCarsLink } from "../../../../utils/tracking";
import { getToyotaButtonVariant } from "../../../../utils/pdpUtils";
import { DealerInfoType } from "../../../../utils/constants";
import { getDealerContactInfoList } from "../../../../utils/helpers";

const DealerInfo = (): JSX.Element | null => {
    const dealer = useUscSelector((state) => state.dealer.dealer);
    const settings = useUscSelector((state) => state.uscSettings);
    const vehicleType = useUscSelector((state) => state.vehicle.type);

    const learnMoreAboutDealer = useUscOptionalLabel("uscPdpLearnMoreAboutDealer");
    const formattedAddress = useUscLabel("uscDealerAddress", dealer?.address);
    const commonSettings = useUscSelector((state) => state.commonSettings);

    if (!dealer) return null;

    const contactInfoList = getDealerContactInfoList(dealer, settings, commonSettings);
    const retailerCarFilterUrl = getUscCarFilterUrlForDealer(
        commonSettings,
        settings.landingPageUrl,
        vehicleType,
        dealer.id,
    );

    return (
        <Styles.Info>
            <div>
                <Text tag="h3" variant="h4" spacing={{ mb: "spacing-3" }}>
                    <div>{dealer.name}</div>
                </Text>

                <Text tag="div" variant="body-book">
                    {formattedAddress.replace(/\\n/g, "\n")}
                </Text>
            </div>
            {contactInfoList.length > 0 && <DealerContactInfo />}

            {/* data-cpdqm="ignore" => Ignore DQM test for the buttons: 2.4 - Indicate when a link will open in a new window/tab */}
            <Styles.Actions data-cpdqm="ignore">
                {learnMoreAboutDealer && settings.showDealerWebsite && !!dealer.website && (
                    <Button
                        variant="outline"
                        href={dealer.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => trackAemContactDealerCtas(DealerInfoType.Website, dealer, vehicleType)}
                    >
                        {learnMoreAboutDealer}
                    </Button>
                )}

                <Button
                    variant={getToyotaButtonVariant(vehicleType, commonSettings.query.blackPrimaryCtas)}
                    href={retailerCarFilterUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackAemDealerSeeCarsLink(vehicleType, dealer)}
                >
                    <UscLabel label="uscPdpDealerCarFilterLink" />
                </Button>
            </Styles.Actions>
        </Styles.Info>
    );
};

export default DealerInfo;
